const werknemerListing = {
	init() {
		// Forward naar geselecteerde jaartal
		const selectElements = document.querySelectorAll('.listing-nav select');
		selectElements.forEach((select) => {
			select.addEventListener('change', function () {
				window.location.href = this.value;
			});
		});
	},
};

export default werknemerListing;
